<template>
  <div class="main mt14 content">
    <div>
      <div class="navbar simple list-group">
        <div class="main">
          <div class="public_title public_t_text">
            <div class="public_t">
              <a @click="prime(name)">{{ name }}</a>
            </div>
          </div>
          <div class="public_subTab_group subTab_group">
            <ul v-for="(item,index) in notice.columnList" :key="index" @click="first(index,item.name,item.showType,item.columnType,item)">
              <li class="nav public_subTab_item subTab_item flex_row_align_center" :class="firstIndex==index?'yesNav':''">
                <a style="display: flex;" class="a flex_row_align_center">
                  <span
                    class="public_subTab_title subTab_item_title"
                    :class="firstIndex==index?'yesfont':''"
                    style="position:relative"
                  >{{ item.name }}</span>
                  <div class="public_dot subTab_dot" :class="firstIndex==index?'yesSpot':''" />
                </a>
              </li>

              <li
                v-for="(res,indexs) in item.childList"
                :key="indexs"
                :class="twoIndex==indexs?'yesNav':''"
                class="nav public_subTab_item subTab_item flex_row_align_center"
                @click.stop="two(indexs,res.name,item.showType,res)"
              >
                <div v-if="item.childList">
                  <a style="display: flex;" class="a flex_row_align_center">
                    <span
                      class="public_subTab_title subTab_dot_child"
                      style="position:relative;left:20px"
                    >&gt;&gt;{{ res.name }}</span>
                    <div class="public_dot subTab_dot" :class="twoIndex==indexs?'yesSpot':''" />
                  </a>
                </div>
              </li>
              <!-- <li class="nav public_subTab_item subTab_item flex_row_align_center">
                <a style="display: flex;" class="a flex_row_align_center">
                  <span
                    class="public_subTab_title subTab_dot_child"
                    style="position:relative;left:20px"
                  >&gt;&gt;民盟遵义市委</span>
                  <div class="public_dot subTab_dot" />
                </a>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="list-page">
        <div class="text-image-list">
          <div class="public_title public_t_text mt14">
            <div class="public_t">
              <a>{{ nextName }}</a>
            </div>
          </div>
          <!-- 图文列表 -->
          <!-- 无图列表 -->
          <div v-for="(item,index) in list.rows" :key="index">
            <!-- <div v-if="notice.showType ==0" class="item">
              <div class="item-texts" style="width:100%">
                <div class="item-title">
                  <a
                    class="link"
                    style="width: 860px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                  >
                    <span style="font-weight:bold;">民盟遵义市委荣获全市统战宣传信息工作一等奖</span>
                  </a>
                </div>
                <div class="item-normal">
                  <span class="source">民盟遵义市委 万岭</span>

                  <span class="time">2020-03-16</span>
                </div>
                <div class="item-descri">
                  <a>&nbsp;在3月6日全市统战部长会议上，中共遵义市委统战部对2019年全市统战宣传信息工作先进单位、先进个人和优秀调研课题进行了表彰。民盟遵义市委获2019年度全市统战信息工作先进单位一等奖，《关于建设黔川渝结合部医疗康养中心的政策研究》获2019年全市统一战线优秀调研课题表彰，万岭同志获2019年全市统战宣传信息工作先进个人称号。2019年民盟...</a>
                </div>
                <div class="item-normal">
                  <a class="goinfo">详情</a>
                  <div style="clear:both" />
                </div>
              </div>
              <div style="clear:both" />
            </div> -->
            <!-- 图文列表 -->
            <div v-if="showType == 1" class="item">
              <div v-if="item.thumbnailPath" class="item-img">
                <a>
                  <img :src="cfg.imageDomain +item.thumbnailPath" @click="jumpNews(item.id,item.customUrl)">
                </a>
              </div>
              <div class="item-texts float" :style="item.thumbnailPath? 'width: 580px':'width: 100%'">
                <div class="item-title">
                  <a
                    class="link"
                    style="width: 860px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                    @click="jumpNews(item.id,item.customUrl)"
                  >
                    <span style="font-weight:bold;">{{ item.title }}</span>
                  </a>
                </div>
                <div class="item-normal">
                  <span class="source">{{ item.author }}</span>

                  <span class="time">{{ item.publishTime | parseTime('{y}-{m}-{d}') }}</span>
                </div>
                <div class="item-descri">
                  <a @click="jumpNews(item.id,item.customUrl)">{{ item.newContent }}</a>
                </div>
                <div class="item-normal">
                  <a class="goinfo" @click="jumpNews(item.id,item.customUrl)">详情</a>
                  <div style="clear:both" />
                </div>
              </div>
              <div style="clear:both" />
            </div>
            <!-- 文字列表 -->
            <div v-if="showType ==0">
              <div class="ranking-list">
                <dl>
                  <dd>
                    <a class="link" @click="jumpNews(item.id,item.customUrl)">
                      <span class="point">
                        <img
                          class="public_item_icon_img"
                          src="https://sf-image.wjzpgz.com/minmeng/attaches/dot.png"
                          alt
                        >
                      </span>
                      <span>{{ item.title }}</span>
                    </a>
                  </dd>
                  <dd class="time">
                    <span>{{ item.publishTime | parseTime('{y}-{m}-{d}') }}</span>
                  </dd>
                </dl>
                <div style="clear:both" />
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="15"
          :total="list.total"
          :current-page.sync="current"
          :hide-on-single-page="value"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getArticleList } from '@/api/common';
import { deleteHtmlTag, handlerStr } from '@/utils';
export default {
  props: { 'notice': {
    type: Object,
    default: null
  }},
  data() {
    return {
      pageSize: '',
      value: true,
      current: 1,
      list: '',
      firstIndex: -1,
      twoIndex: -1,
      addressName: '',
      name: '',
      nextName: '',
      showType: ''
    };
  },
  watch: {
    '$route'(to, from) {
      this.refresh(this.$route.query.name)
    }

  },
  created: function() {
    this.handleCurrentChange(1);
  },
  methods: {
    refresh() {
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      // this.list = ''
      this.name = this.notice.name;
      if (!this.nextName) {
        this.nextName = this.$route.query.name
      }
      const newNameList = []
      newNameList.push(this.notice.name)
      for (let i = 0; i < this.notice.columnList.length; i++) {
        newNameList.push(this.notice.columnList[i].name)
      }
      this.firstIndex = newNameList.indexOf(this.nextName) - 1
      if (this.firstIndex > -1) {
        this.showType = this.notice.columnList[this.firstIndex].showType
      }
      let data = '';
      if (newNameList.indexOf(this.nextName) === 0) {
        data = this.buildParams({ pageNo: val, pageSize: 15, columnName: this.nextName });
      } else {
        data = this.buildParams({ pageNo: val, pageSize: 15, columnName: this.nextName });
      }
      getArticleList(data).then(res => {
        this.list = res.data
        for (let i = 0; i < res.data.rows.length; i++) {
          this.list.rows[i].newContent = this.list.rows[i].content && this.handlerStr(this.list.rows[i].content)
        }
      })
    },
    jumpNews(id, customUrl) {
      if (customUrl) {
        var windowOpen = window.open()
        windowOpen.location = customUrl;
      } else {
        this.$router.push({ path: '/news', query: { id: id }});
      }
      // this.$router.push({ path: '/news', query: { id: id }});
    },
    first(index, name, showType, columnType, item) {
      this.firstIndex = index
      this.twoIndex = -1
      this.nextName = name
      this.showType = showType
      this.current = 1
      if (columnType === 1) {
        this.$router.push({ path: '/news', query: { columnName: name }});
      } else {
        this.$router.push({ path: '/subPage', query: { name: name }});
      }
      // this.$emit('handlerCrumbs', { columnName: name, column: item });
      // const data = this.buildParams({ pageNo: 1, pageSize: 15, columnName: name });
      // getArticleList(data).then(res => {
      //   this.list = res.data
      //   for (let i = 0; i < res.data.rows.length; i++) {
      //     this.list.rows[i].newContent = this.handlerStr(this.list.rows[i].content)
      //   }
      // })
    },
    two(index, name, showType, item) {
      this.twoIndex = index
      this.nextName = name
      this.showType = showType
      const data = this.buildParams({ pageNo: 1, pageSize: 15, columnName: name });
      this.$emit('handlerCrumbs', { columnName: name, column: item });
      this.current = 1;
      getArticleList(data).then(res => {
        this.list = res.data
        for (let i = 0; i < res.data.rows.length; i++) {
          this.list.rows[i].newContent = this.handlerStr(this.list.rows[i].content)
        }
      })
    },
    prime(name) {
      this.firstIndex = -1
      this.nextName = name
      const data = this.buildParams({ pageNo: 1, pageSize: 15, columnName: name });
      getArticleList(data).then(res => {
        this.list = res.data
        for (let i = 0; i < res.data.rows.length; i++) {
          this.list.rows[i].newContent = this.handlerStr(this.list.rows[i].content)
        }
      })
    },
    handlerStr(str) {
      return str && handlerStr(deleteHtmlTag(str), 200)
    }
  }

};
</script>
<style scoped>
iframe,
body,
table,
a,
li,
dd {
  margin: 0;
  padding: 0;
  border: 0;
  color: #3c3c3c;
  font-size: 14px;
  font-family: 宋体;
}
.content {
  min-height: 500px;
}
.mt14 {
  margin-top: 14px;
}

.main {
  overflow: hidden;
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  position: relative;
}
.navbar.simple {
  background: #fff;
  display: inline-block;
  height: auto;
  position: relative;
  top: 15px;
}
.navbar.simple .main {
  width: 260px;
  padding: 0;
  margin: 0 auto;
  position: relative;
}
.public_t_text {
  font: 400 14px/22px PingFangSC;
  color: #fff;
  background: #e4effa;
}
.public_title {
  background: #e4effa;
  padding-right: 14px;
  position: relative;
}
.public_t {
  padding: 9px 28px;
  color: #fff;
  background: #367dbe;
  display: inline-block;
  font: 400 16px/22px PingFangSC;
}
.public_t a {
  font: 400 14px/22px PingFangSC;
  color: #fff;
}
a {
  text-decoration: none;
}
.navbar ul,
.navbar li {
  list-style-type: none;
}

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.list-group .subTab_group {
  border: 1px solid #d9d9d9;
  border-bottom: none;
}
.list-group .subTab_group .subTab_item {
  max-height: 50px;
  max-width: 258px;
  padding: 14px 20px;
  width: 260px;
  border-bottom: 1px solid #d9d9d9;
}
.navbar .nav {
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.navbar li {
  list-style-type: none;
}

.public_title {
  background: #e4effa;
  padding-right: 14px;
  position: relative;
}
.public_t_text {
  font: 400 14px/22px PingFangSC;
  color: #fff;
  background: #e4effa;
}
.navbar.simple .nav a {
  line-height: 0;
  color: #000;
  text-align: center;
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;
  font: normal 16px 微软雅黑, Arail, Verdana;
  text-decoration: none;
  line-height: 50px;
}
.flex_row_align_center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.list-group .subTab_group .subTab_item .subTab_item_title {
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  font: 600 16px/22px PingFangSC;
  color: #4b4b4b;
}
.public_subTab_group .public_subTab_item .public_dot {
  width: 8px;
  height: 8px;
  border: 1px solid #9b9b9b;
  border-radius: 50%;
  margin-left: 21px;
}
.list-group .subTab_group .subTab_item {
  max-height: 50px;
  max-width: 258px;
  padding: 14px 20px;
  width: 260px;
  border-bottom: 1px solid #d9d9d9;
}
.navbar.simple .nav a {
  display: flex;
  line-height: 0;
  color: #000;
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;
  font: normal 16px 微软雅黑, Arail, Verdana;
  text-decoration: none;
  line-height: 50px;
}
.public_subTab_group .public_subTab_item .public_subTab_title {
  font: 600 16px/22px PingFangSC;
  color: #4b4b4b;
  position: relative;
  left: 20px;
}
.main .list-page {
  width: 919px;
  float: right;
  flex: 1;
  margin-left: 20px;
  min-height: 650px;

}
.main .list-page .text-image-list .item {
  clear: both;
  background: #fff;
  margin-bottom: 15px;
}
.main .list-page .text-image-list .item .item-texts {
  width: 100%;
  padding: 20px;
}
.main .list-page .text-image-list .item a.link {
  font-size: 18px;
  line-height: 30px;
  color: #333333;
  text-decoration: none;
  clear: both;
}
.main .list-page .text-image-list .item a.link:hover {
  color: #c30734;
}
.main .list-page .text-image-list .item .item-normal {
  clear: both;
  line-height: 30px;
  font-size: 12px;
  color: #9b9b9b;
}
.main .list-page .text-image-list .item .item-descri {
  clear: both;
  color: #9b9b9b;
  line-height: 20px;
   word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

a:hover {
  color: #2386e2;
  text-decoration: underline;
}
.main .list-page .text-image-list .item .item-normal {
  clear: both;
  line-height: 30px;
}
.main .list-page .text-image-list .item .goinfo {
  margin-bottom: 10px 0 0 20px;
  font-size: 12px;
  padding: 0 20px 0 20px;
  float: right;
  text-decoration: none;
  border: 1px solid #ccc;
  color: #9b9b9b;
}
.main .list-page .text-image-list .item .goinfo:hover {
  border: 1px solid #c30734;
  background: #c30734;
  color: #fff;
}

.main .list-page .text-image-list .item .item-img {
  float: left;
  width: 336px;
  height: 184px;
}
.main .list-page .text-image-list .item .item-img img {
  float: left;
  width: 336px;
  height: 184px;
  border: 0;
}
.main .list-page .text-image-list .item .item-texts.float {
  min-width: 580px;
  width: 580px;
  float: right;
}

.minHeight{

}
.ranking-list dl {
  clear: both;
  background: #fff;
  margin-bottom: 0px;
  overflow: hidden;
  padding: 3px;
  margin-top: 0;
}
.ranking-list dl dd {
  float: left;
  line-height: 30px;
}
.ranking-list dl dd a.link {
  font-size: 14px;
  float: left;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  white-space: nowrap;
}
.ranking-list dl dd a.link:hover {
  color: #367dbe;
  text-decoration: underline;
}
.ranking-list dl dd .point {
  color: #c30734;
  font-size: 18px;
  margin-left: 10px;
}
.public_item_icon_img {
  width: 9px;
  height: 8px;
  margin: 5px;
  vertical-align: middle;
}
.ranking-list dl dd.time {
  float: right;
  font-size: 14px;
  color: #888;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}
.pagination > li {
  display: inline;
}
.pagination > li:first-child > a {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.pagination > .active > a {
  z-index: 3;
  color: #fff;
  cursor: default;
  background-color: #337ab7;
  border-color: #337ab7;
}

.pagination > li > a {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}
.pagination > li > a:hover {
  z-index: 2;
  color: #23527c;
  background-color: #eee;
  border-color: #ddd;
}
.source{
  margin-right: 5px;
}
.el-pagination{
  text-align: center;
}
.yesNav{
  background: #ECF4FC;
}
.yesfont{
  color: #367DBE !important;
}
.yesSpot{
  background: #367DBE;
}

</style>
